import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const loadBranches = createAsyncThunk(
    'branches/loadBranches',
    async ({bankId, token}) => {
        const response = fetch(`${process.env.REACT_APP_BASE_URL}/teller/branches/${bankId}`,
            {
                method: 'GET',
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        .then(response => response.json());
        return response;
    }
)

export const loadAllBranches = createAsyncThunk(
    'branches/loadAllBranches',
    async (token) => {
        const response = fetch(`${process.env.REACT_APP_BASE_URL}/admin/branches`,
            {
                method: 'GET',
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        .then(response => response.json());
        return response;
    }
)

export const branchesSlice = createSlice({
    name: 'branches',
    initialState: {
        branches: [],
        branchesLoading: false,
        failedToLoadBranches: false
    },
    reducers: {
        addBranch: (state, action) => {
            return {
                ...state,
                branches: [...state.branches, action.payload]
            }
        },
        updateBranchInfo: (state, action) => {
            const newBranchList = state.branches.map(branch => {
                if (branch.branchId === action.payload.branchId) {
                    return {
                        ...branch,
                        branchName: action.payload.branchName
                    }
                } else {
                    return branch;
                }
            })
            return {
                ...state,
                branches: newBranchList
            }
        },
        removeBranch: (state, action) => {
            const newBranchList = state.branches.filter(branch => branch.branchId !== action.payload);
            return {
                ...state,
                branches: newBranchList
            }
        },
        clearBranches: (state) => {
            return {
                ...state,
                branches: []
            }
        }
    },
    extraReducers: {
        [loadBranches.pending]: (state) => {
            return {
                ...state,
                branchesLoading: true,
                failedToLoadBranches: false
            }
        },
        [loadBranches.fulfilled]: (state, action) => {
            return {
                ...state,
                branches: action.payload,
                branchesLoading: false,
                failedToLoadBranches: false
            }
        },
        [loadBranches.rejected]: (state) => {
            return {
                ...state,
                branchesLoading: false,
                failedToLoadBranches: true
            }
        },
        [loadAllBranches.pending]: (state) => {
            return {
                ...state,
                branchesLoading: true,
                failedToLoadBranches: false
            }
        },
        [loadAllBranches.fulfilled]: (state, action) => {
            return {
                ...state,
                branches: action.payload,
                branchesLoading: false,
                failedToLoadBranches: false
            }
        },
        [loadAllBranches.rejected]: (state) => {
            return {
                ...state,
                branchesLoading: false,
                failedToLoadBranches: true
            }
        }
    }
})

export const selectBranches = (state) => state.branches.branches;
export const branchesLoading = (state) => state.branches.branchesLoading;

export const { addBranch, updateBranchInfo, removeBranch, clearBranches } = branchesSlice.actions;

export default branchesSlice.reducer;